export default "__VITE_ASSET__32bbcf0f__"